import * as React from 'react';
import { MediaQuery, Tooltip } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const LabelWithTooltip = ({ type , id  })=>{
    const intl = useIntl();
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const showLabel = isMobile || id === 'right';
    return showLabel ? /*#__PURE__*/ React.createElement("div", {
        className: "contact-lens-tooltip__wrapper"
    }, /*#__PURE__*/ React.createElement("label", {
        className: "contact-lens-tooltip__label"
    }, intl.getLabel(`products.contactLenses.prescription.${type}`)), /*#__PURE__*/ React.createElement(Tooltip, {
        className: "contact-lens-tooltip",
        "data-t": `tooltip-${id}`,
        id: `${type}-${id}`,
        message: intl.getLabel(`products.contactLenses.prescription.${type}.tooltip`)
    })) : null;
};

export { LabelWithTooltip };
//# sourceMappingURL=LabelWithTooltip.js.map
